<template>
  <div v-swiper:mySwiper="swiperOption" id="HeroSlider">
    <div class="sliderText">
      <img src="@/assets/logos/logo_GLF-white.svg" alt="Globe Life Field" />
      <div class="titleSection">
        <h2>{{ sliderImages[0].title }}</h2>
        <span>{{ sliderImages[0].subTitle }}</span>
      </div>
      <div class="line-break"></div>
      <p>{{ sliderImages[0].desc }}</p>
      <div class="sliderLinks">
        <div
          class="sliderLink"
          :key="'SliderLink' + link.linkTitle"
          v-for="link in sliderImages[0].links"
        >
          <h4>{{ link.linkTitle }}</h4>
          <div class="link-line-break"></div>
          <p>{{ link.linkDesc }}</p>
          <b-button :to="link.linkURL">Learn More</b-button>
        </div>
      </div>
      <a
        v-if="buttonInfo"
        class="button"
        :href="buttonInfo.link"
        target="_blank"
        >{{ buttonInfo.text }}</a
      >
    </div>
    <div class="swiper-wrapper" id="swiper-header">
      <div
        class="swiper-slide"
        :key="'SliderImage' + sliderImg.imgNum"
        v-for="sliderImg in sliderImages"
      >
        <img :src="require(`@/assets/images/${sliderImg.imgSrc}`)" />
        <div v-if="!isMobile" class="sliderCaption">
          <p>{{ sliderImg.caption }}</p>
          <div class="caption-line"></div>
        </div>
        <div v-if="!isMobile" class="vignette vignette-left"></div>
        <div v-if="!isMobile" class="vignette vignette-right"></div>
        <div v-if="isMobile" class="blue-overlay"></div>
      </div>
    </div>
    <div
      v-if="!isMobile"
      class="swiper-pagination swiper-pagination-white"
    ></div>
    <div
      v-if="!isMobile"
      class="swiper-button-prev swiper-button-white"
      slot="button-prev"
    ></div>
    <div
      v-if="!isMobile"
      class="swiper-button-next swiper-button-white"
      slot="button-next"
    ></div>
  </div>
</template>

<script>
export default {
  name: "HeroSlider",
  props: {
    sliderImages: {
      type: Array,
    },
    buttonInfo: {
      type: Object,
    },
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        speed: 2000,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 992;
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-container {
  top: 53px;
  height: calc((100vw - 53px) / 16 * 9);
  width: 100vw;
  // aspect-ratio: 16 / 9;
  @media only screen and (max-width: $lg) {
    height: calc(100vh - 53px);
  }
  .sliderText {
    z-index: 11;
    // Large
    @media only screen and (max-width: $xl) {
      width: 50%;
    }
    // Mobile
    @media only screen and (max-width: $lg) {
      width: 100%;
      background-image: linear-gradient(
        180deg,
        rgba(248, 248, 248, 0.2),
        rgba(197, 197, 197, 0.2)
      );
      -webkit-backdrop-filter: blur(0px);
      backdrop-filter: blur(0px);
    }
    // Desktop
    // center vertical and horizontal
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 10;
    transform: translate(-50%, -50%);
    // flex
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // display
    height: 100%;
    width: 35%;
    // background
    background-image: linear-gradient(
      180deg,
      rgba(248, 248, 248, 0.5),
      rgba(197, 197, 197, 0.5)
    );
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    // child styles
    color: #fff;
    img {
      width: 35%;
      height: auto;
      padding: 0 0 6% 0;
      @media (max-width: 1100px) {
        padding: 0 0 3%;
      }
    }
    .titleSection {
      font-family: "BertholdCondensed";
      font-size: 92px;
      line-height: 74px;
      h2 {
        font-size: 92px;
        font-weight: 700;
        margin: 0;
        line-height: 74px;
        @media (max-width: 1100px) {
          font-size: 82px;
          line-height: 60px;
        }
      }
    }
    .line-break {
      background-color: #fff;
      width: 70px;
      height: 2px;
      margin: 2% 0 0;
    }
    p {
      padding: 5% 20%;
      font-size: 16px;
      font-weight: 500;
      @media only screen and (max-width: 1270px) {
        padding: 5% 10% 0;
      }
      @media (max-width: 1100px) {
        font-size: 14px;
        padding: 4% 8% 0;
      }
    }

    .sliderLinks {
      // Mobile
      @media only screen and (max-width: $md) {
        flex-direction: column;
        align-content: center;
        width: 90%;
      }
      // flex
      display: flex;
      justify-content: space-evenly;
      gap: 8px;
      // child styles
      color: $dark-blue;
      .sliderLink {
        // Mobile
        @media only screen and (max-width: $md) {
          width: 100%;
        }
        // flex
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 50%;
        // background
        background-image: linear-gradient(
          180deg,
          rgba(248, 248, 248, 1),
          rgba(197, 197, 197, 1)
        );
        // styles
        border-radius: 5px;
        box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px,
          rgba(0, 0, 0, 0.22) 0px 15px 12px;
        z-index: 11;
        h4 {
          font-family: "BertholdCondensed";
          font-weight: 700;
          font-size: 25px;
          text-transform: uppercase;
          width: 80px;
          padding: 10% 0 0 0;
          @media only screen and (max-width: $md) {
            padding: 5% 0 0 0;
          }
        }
        .link-line-break {
          background-color: #000;
          width: 35px;
          height: 1px;
        }
        p {
          font-size: 12px;
          font-weight: 400;
          padding: 5% 15% 10% 15%;
          @media only screen and (max-width: $xl) {
            padding: 5% 10% 0;
          }
          @media only screen and (max-width: $md) {
            padding: 0 32%;
          }
        }
        .btn {
          text-transform: uppercase;
          font-size: 13px;
          font-weight: 900;
          background-image: linear-gradient(90deg, #2c343e, $dark-blue);
          border: none;
          margin: 0 5% 5%;
          width: 90%;
          @media only screen and (max-width: $md) {
            margin: 0 2% 2%;
            width: 97%;
          }
        }
      }
    }
    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: "Gotham";
      font-size: 11px;
      font-weight: 900;
      color: #fff;
      text-transform: uppercase;
      text-decoration: none;
      margin-top: 25px;
      background-color: #2d984b;
      height: 40px;
      padding: 0 25px;
      border-radius: 8px;
    }
  }
  .swiper-wrapper {
    .swiper-slide {
      position: relative;
      img {
        // height: calc(100vw / 16 * 8 - 53px);
        height: calc((100vw - 53px) / 16 * 9);
        width: 100vw;
        @media only screen and (max-width: $lg) {
          height: calc(100vh - 53px);
          width: auto;
        }
      }
      .sliderCaption {
        position: absolute;
        right: 2%;
        bottom: 3%;
        display: flex;
        align-items: center;
        z-index: 10;
        p {
          font-family: "BertholdCondensed";
          font-size: 15px;
          font-weight: 700;
          color: #fff;
          margin: 0;
        }
        .caption-line {
          height: 1.25em;
          width: 2px;
          background-color: #fff;
          margin: 0 0 0 4px;
        }
      }
      .vignette {
        height: 100%;
        width: 25%;
      }
      .vignette.vignette-left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
        background-image: linear-gradient(
          270deg,
          rgba(4, 12, 24, 0),
          rgba(4, 12, 24, 0.7)
        );
      }
      .vignette.vignette-right {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(0, -50%);
        background-image: linear-gradient(
          90deg,
          rgba(4, 12, 24, 0),
          rgba(4, 12, 24, 0.7)
        );
      }
      .blue-overlay {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(0, -50%);
        background-color: rgba(4, 12, 24, 0.6);
      }
    }
  }
}
// Swiper Buttons

// Swiper Pagination
.swiper-pagination {
  width: fit-content !important;
  left: auto !important;
  right: 2% !important;
  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    transform: rotate(45deg);
    display: inline-block;
    background: #000;
    opacity: 0.2;
  }
}
</style>
